import { render, staticRenderFns } from "./add-action.vue?vue&type=template&id=3614ae5e&scoped=true&"
import script from "./add-action.vue?vue&type=script&lang=js&"
export * from "./add-action.vue?vue&type=script&lang=js&"
import style0 from "./add-action.vue?vue&type=style&index=0&id=3614ae5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3614ae5e",
  null
  
)

export default component.exports